/**
 * Model access forbidden page.
 * Shown when the user doesn't have permission to access a specific model.
 */
import { Link, useParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import AuroraBackground from '@/components/layout/AuroraBackground';
import '../ModelBuilderPage/styles.css';

export default function ModelForbiddenPage() {
  const { modelId } = useParams();

  return (
    <>
      <AuroraBackground />
      <div className="min-h-[var(--app-content-height)] px-4 py-12">
        <div className="mb-forbidden-card">
          <FontAwesomeIcon icon={faBan} className="mb-forbidden-icon" />
          <h2 className="text-xl font-semibold mb-2 text-aurora-text" >
            Access Denied
          </h2>
          <p className="text-sm mb-6 text-aurora-text-muted/70" >
            You do not have permission to access model{' '}
            <code
              className="text-xs px-2 py-0.5 rounded-sm"
              style={{
                background: 'rgb(var(--brew-blue-light) / 0.08)',
                border: '1px solid rgb(var(--brew-blue-light) / 0.14)',
                color: '#7cc8e8',
              }}
            >
              {modelId}
            </code>
            .
          </p>
          <Link to="/dashboard/build" className="aurora-btn aurora-btn-primary">
            <FontAwesomeIcon icon={faArrowLeft} />
            Back to Build
          </Link>
        </div>
      </div>
    </>
  );
}
